// extracted by mini-css-extract-plugin
export default {"pageLoader":"page-loader_pageLoader__viioW","content":"page-loader_content__X68sH","loaderIcon":"page-loader_loaderIcon__2rmuY","loaderText":"page-loader_loaderText__lOpVy"};